import React from 'react'
import { PaymentCard } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const AsideDecoration = ({ title, className, ...props }) => (
  <div className={className}>
    <PaymentCard {...props}>{title}</PaymentCard>
  </div>
)

AsideDecoration.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
}

export default AsideDecoration
